const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },

  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  headerContainer: {
    flex: '1 0 0',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  typeContainer: {
    display: 'flex',
    height: '180px',
    padding: '12px',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: 'var(--mcg-bg, #F4F6F8)',
    maxWidth: '288px',
  },
  typeContent: {
    display: 'flex',
    padding: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: '#F4F6F8',
  },
  typeDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',

    maxWidth: '288px',
  },
  typeText: {
    overflow: 'hidden',
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
})

export default styles
